import { render, staticRenderFns } from "./DoubleLine.vue?vue&type=template&id=38afa7e2"
import script from "./DoubleLine.vue?vue&type=script&lang=js"
export * from "./DoubleLine.vue?vue&type=script&lang=js"
import style0 from "./DoubleLine.vue?vue&type=style&index=0&id=38afa7e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports